import React from 'react';
import PricingSettings from '../components/Settings/PricingSettings';
import { useAuth } from '../contexts/AuthContext';
import './PresetsPage.css';

/**
 * Presets page that contains pricing presets
 */
const PresetsPage = ({ onBack }) => {
  const { user } = useAuth();

  // If not authenticated, show message
  if (!user) {
    return (
      <div className="presets-page">
        <div className="presets-content-full">
          <div className="presets-auth-message">
            <h2>Pricing Presets</h2>
            <p>Please log in to access pricing presets.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="presets-page">
      <div className="presets-content-full">
        <div className="presets-header">
          <button className="back-button" onClick={onBack}>
            ← Back
          </button>
        </div>
        <PricingSettings />
      </div>
    </div>
  );
};

export default PresetsPage; 